import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/industries/industrial-complexes/components/IndustrialComplexesView.tsx");
